import script from "./Print.vue?vue&type=script&setup=true&lang=js"
export * from "./Print.vue?vue&type=script&setup=true&lang=js"

import "./Print.vue?vue&type=style&index=0&id=040cc62e&scoped=true&lang=css"

import exportComponent from "D:\\nodejs\\wys02\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-040cc62e"]])

export default __exports__